import { jwtDecode } from 'jwt-decode';  // Correct way to import the named export

// Function to decode JWT token and extract the role
export const getToken = () => {
  const token = localStorage.getItem('authToken'); // Get the token from localStorage
  if (token) {
    
    const decodedToken = jwtDecode(token); // Decode the JWT token using jwtDecode
    
    return decodedToken; // Extract the role claim from the decoded token
  }
  return null; // If token doesn't exist, return null
};




// Function to decode JWT token and extract the role
export const getRoleFromToken = () => {
  const token = localStorage.getItem('authToken'); // Get the token from localStorage
  
  if (token) {
    try {
      const decodedToken = jwtDecode(token); // Decode the JWT token using jwtDecode
      
      // Extract the role from the decoded token and normalize it (lowercase and remove spaces)
      if (decodedToken && decodedToken.role) {
        return decodedToken.role.toLowerCase().replace(/\s+/g, ''); // Normalize role (lowercase and remove spaces)
      } else {
        return null; // If no role is found in the token, return null
      }
    } catch (error) {
      console.error("Error decoding the token", error); // Log errors if any
      return null; // Return null if the token is invalid
    }
  }
  
  return null; // If no token is found, return null
};

export const getDepartmentIdFromToken = () => {
  const token = localStorage.getItem('authToken');
  if (token) {
    try {
      
      const decodedToken = jwtDecode(token); // Decode the JWT token
      if (decodedToken && decodedToken.groupsid) {
        return decodedToken.groupsid; // Return the department_id if available
      }
      return null; // Return null if no department_id is found
    } catch (error) {
      console.error("Error decoding the token", error);
      return null; // Return null if decoding fails
    }
  }
  return null; // Return null if no token is found
};

export const getUserFromToken = () => {
  const token = localStorage.getItem('authToken');
  if (token) {
    try {
      
      const decodedToken = jwtDecode(token); // Decode the JWT token
      
      if (decodedToken && decodedToken.nameid) {
        return decodedToken.nameid; // Return the department_id if available
      }
      return null; // Return null if no department_id is found
    } catch (error) {
      console.error("Error decoding the token", error);
      return null; // Return null if decoding fails
    }
  }
  return null; // Return null if no token is found
};

export const getUserIDFromToken = () => {
  const token = localStorage.getItem('authToken');
  if (token) {
    try {
      
      const decodedToken = jwtDecode(token); // Decode the JWT token
      
      if (decodedToken && decodedToken.user_id) {
        return decodedToken.user_id; // Return the department_id if available
      }
      return null; // Return null if no department_id is found
    } catch (error) {
      console.error("Error decoding the token", error);
      return null; // Return null if decoding fails
    }
  }
  return null; // Return null if no token is found
};

export const getCompanyCodeFromToken = () => {
  const token = localStorage.getItem('authToken');
  if (token) {
    try {
      
      const decodedToken = jwtDecode(token); // Decode the JWT token
      
      if (decodedToken && decodedToken.companyCode) {
        return decodedToken.companyCode; // Return the department_id if available
      }
      return null; // Return null if no department_id is found
    } catch (error) {
      console.error("Error decoding the token", error);
      return null; // Return null if decoding fails
    }
  }
  return null; // Return null if no token is found
}; 

export const getIsDepartmentRestrictedToken = () => {
  const token = localStorage.getItem('authToken');

  if (token) {
    try {
      const decodedToken = jwtDecode(token);
      if (decodedToken && typeof decodedToken.IsDepartmentRestricted !== 'undefined') {
        return String(decodedToken.IsDepartmentRestricted).toLowerCase(); // always returns 'true' or 'false'
      }
    } catch (error) {
      console.error("Error decoding the token", error);
    }
  }

  return null;
};